export default __webpack_public_path__ + "static/media/52e22c12b042963926d1e5340350b1da.svg";